import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  campaignType: (
    <FormattedMessage
      id="Global.CampaignType"
      defaultMessage="Campaign Type:"
    />
  ),
  subCategory: (
    <FormattedMessage id="Global.SubCategory" defaultMessage="Sub Category:" />
  ),
  messageDetails: (
    <FormattedMessage
      id="Global.MessageDetails"
      defaultMessage="MESSAGE DETAILS"
    />
  ),
  vertical: (
    <FormattedMessage id="Global.Vertical" defaultMessage="Vertical:" />
  ),
  description: (
    <FormattedMessage id="Global.Description" defaultMessage="Description:" />
  ),
  sampleMessages: (
    <FormattedMessage
      id="Global.SampleMessages"
      defaultMessage="Sample Messages:"
    />
  ),
  sample1: <FormattedMessage id="Global.Sample1" defaultMessage="Sample 1:" />,
  sample2: <FormattedMessage id="Global.Sample2" defaultMessage="Sample 2:" />,
  sample3: <FormattedMessage id="Global.Sample3" defaultMessage="Sample 3:" />,
  sample4: <FormattedMessage id="Global.Sample4" defaultMessage="Sample 4:" />,
  sample5: <FormattedMessage id="Global.Sample5" defaultMessage="Sample 5:" />,
  messageAttributes: (
    <FormattedMessage
      id="Global.MessageAttributes"
      defaultMessage="MESSAGE ATTRIBUTES"
    />
  ),
  subscriberOptIn: (
    <FormattedMessage
      id="Global.SubscriberOptIn"
      defaultMessage="Subscriber Opt-in"
    />
  ),
  keyWords: (
    <FormattedMessage id="Global.KeyWords" defaultMessage="Key Words:" />
  ),
  message: <FormattedMessage id="Global.Message" defaultMessage="Message:" />,
  subscriberOptOut: (
    <FormattedMessage
      id="Global.SubscriberOptOut"
      defaultMessage="Subscriber Opt-out"
    />
  ),
  subscriberHelp: (
    <FormattedMessage
      id="Global.SubscriberHelp"
      defaultMessage="Subscriber Help"
    />
  ),
  embeddedLink: (
    <FormattedMessage id="Global.EmbeddedLink" defaultMessage="Embedded Link" />
  ),
  link: <FormattedMessage id="Global.Link" defaultMessage="Link:" />,
  embeddedPhone: (
    <FormattedMessage
      id="Global.EmbeddedPhone"
      defaultMessage="Embedded Phone"
    />
  ),
  phoneNumber: (
    <FormattedMessage id="Global.PhoneNumber" defaultMessage="Phone Number:" />
  ),
  numberPooling: (
    <FormattedMessage
      id="Global.NumberPooling"
      defaultMessage="Number Pooling"
    />
  ),
  directLendingOrLoanArrangements: (
    <FormattedMessage
      id="Global.DirectLendingOrLoanArrangements"
      defaultMessage="Direct Lending or Loan Arrangements"
    />
  ),
  affiliateMarketing: (
    <FormattedMessage
      id="Global.AffiliateMarketing"
      defaultMessage="Affiliate Marketing"
    />
  ),
  ageGatedContent: (
    <FormattedMessage
      id="Global.AgeGatedContent"
      defaultMessage="Age-gated Content"
    />
  ),
  optInDetails: (
    <FormattedMessage
      id="Global.OptInDetails"
      defaultMessage="OPT-IN DETAILS"
    />
  ),
  serviceAgreement: (
    <FormattedMessage
      id="Global.ServiceAgreement"
      defaultMessage="Service Agreement:"
    />
  ),
  privacyPolicy: (
    <FormattedMessage
      id="Global.PrivacyPolicy"
      defaultMessage="Privacy Policy:"
    />
  ),
  optInMethod: (
    <FormattedMessage id="Global.OptInMethod" defaultMessage="Opt-In Method:" />
  ),
  providedAttachments: (
    <FormattedMessage
      id="Global.ProvidedAttachments"
      defaultMessage="Provided Attachments:"
    />
  ),
  downloadAll: (
    <FormattedMessage id="Global.DownloadAll" defaultMessage="Download All" />
  ),
  associatedNumbers: (
    <FormattedMessage
      id="Global.AssociatedNumbers"
      defaultMessage="ASSOCIATED NUMBERS"
    />
  ),
  dedicatedPhoneNumber: (
    <FormattedMessage
      id="Global.DedicatedPhoneNumber"
      defaultMessage="Phone Number"
    />
  ),
  user: <FormattedMessage id="Global.User" defaultMessage="User" />,
  CSP: <FormattedMessage id="Global.CSP" defaultMessage="CSP:" />,
  autoRenewal: (
    <FormattedMessage id="Global.AutoRenewal" defaultMessage="Auto Renewal:" />
  ),
  DCA: <FormattedMessage id="Global.DCA" defaultMessage="DCA:" />,
  mock: <FormattedMessage id="Global.Mock" defaultMessage="Mock:" />,
  edit: <FormattedMessage id="Global.Edit" defaultMessage="Edit" />,
  campaignNameTable: (
    <FormattedMessage
      id="Global.CampaignNameTable"
      defaultMessage="Campaign Name"
    />
  ),
  campaignTypeTable: (
    <FormattedMessage
      id="Global.CampaignTypeTable"
      defaultMessage="Campaign Type"
    />
  ),
  verticalTable: (
    <FormattedMessage id="Global.Vertical" defaultMessage="Vertical" />
  ),

  statusTable: <FormattedMessage id="Global.Status" defaultMessage="Status" />,
  activeNumbersTable: (
    <FormattedMessage
      id="Global.ActiveNumbers"
      defaultMessage="Active Numbers"
    />
  ),
  autoRenewalTable: (
    <FormattedMessage id="Global.AutoRenewal" defaultMessage="Auto Renewal" />
  ),
  nextRenewalExpirationDate: (
    <FormattedMessage
      id="Global.NextRenewalExpirationDate"
      defaultMessage="Next Renewal/Expiration Date"
    />
  ),
};

export default FormattedMessages;
